import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { ArrowLeft, MapPin, Hash } from 'lucide-react';
import Card from '../../components/ui/Card';
import Badge from '../../components/ui/Badge';
import Avatar from '../../components/ui/Avatar';
import Button from '../../components/ui/Button';
import Table from '../../components/ui/Table';
import { stores, employees, tasks, analyticsData } from '../../data/mockData';

export default function StoreCard() {
  const { id } = useParams();
  const navigate = useNavigate();
  const store = stores.find(s => s.id === id) || stores[0];
  const storeEmployees = employees.filter(e => e.storeIds.includes(store.id));
  const storeTasks = tasks.filter(t => t.storeId === store.id);
  const storeStats = analyticsData.byStore.find(s => s.storeId === store.id);

  const empColumns = [
    { key: 'name', label: 'Сотрудник', render: (v, row) => (
      <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
        <Avatar name={row.name} size={30} />
        <div>
          <div style={{ fontWeight: 600, fontSize: 13 }}>{row.name}</div>
          <div style={{ fontSize: 11, color: '#8E8E93' }}>{row.role}</div>
        </div>
      </div>
    )},
    { key: 'status', label: 'Статус', render: v => <Badge variant={v}>{v === 'online' ? 'Онлайн' : v === 'vacation' ? 'В отпуске' : 'Офлайн'}</Badge> },
    { key: 'tasksCompleted', label: 'Задач', render: v => <span style={{ fontWeight: 700, color: '#4A6CF7' }}>{v}</span> },
    { key: 'actions', label: '', sortable: false, render: (_, row) => (
      <button onClick={() => navigate(`/employees/${row.id}`)} style={{ fontSize: 11, padding: '4px 10px', borderRadius: 6, border: '1px solid #4A6CF7', background: '#EEF2FF', cursor: 'pointer', color: '#4A6CF7' }}>Профиль</button>
    )},
  ];

  const taskColumns = [
    { key: 'title', label: 'Задача', render: v => <span style={{ fontWeight: 500, fontSize: 13 }}>{v}</span> },
    { key: 'type', label: 'Тип', render: v => <Badge variant={v === 'osg' ? 'osg' : 'display'}>{v === 'osg' ? 'ОСГ' : 'Выкладка'}</Badge> },
    { key: 'status', label: 'Статус', render: v => <Badge variant={v}>{v === 'pending' ? 'Ожидает' : v === 'in_progress' ? 'В работе' : 'Завершено'}</Badge> },
    { key: 'priority', label: 'Приоритет', render: v => <Badge variant={v === 'urgent' ? 'urgent' : 'normal'}>{v === 'urgent' ? 'Срочный' : 'Обычный'}</Badge> },
  ];

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
        <Button variant="ghost" icon={<ArrowLeft size={15} />} onClick={() => navigate('/stores')} size="sm">Назад</Button>
        <span style={{ color: '#D1D5DB' }}>/</span>
        <span style={{ fontSize: 13, color: '#6B7280' }}>{store.name}</span>
      </div>

      <Card>
        <div style={{ display: 'flex', gap: 20, alignItems: 'flex-start', flexWrap: 'wrap' }}>
          <div style={{ width: 64, height: 64, borderRadius: 16, background: 'linear-gradient(135deg, #4A6CF7, #7C3AED)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
            <span style={{ fontSize: 28 }}>🏪</span>
          </div>
          <div style={{ flex: 1 }}>
            <h2 style={{ fontSize: 20, fontWeight: 800, color: '#1A1A2E' }}>{store.name}</h2>
            <div style={{ display: 'flex', gap: 16, marginTop: 6, flexWrap: 'wrap' }}>
              <span style={{ display: 'flex', alignItems: 'center', gap: 5, fontSize: 13, color: '#6B7280' }}><Hash size={13} />{store.code}</span>
              <span style={{ display: 'flex', alignItems: 'center', gap: 5, fontSize: 13, color: '#6B7280' }}><MapPin size={13} />{store.address}</span>
            </div>
          </div>
        </div>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 16, marginTop: 20, paddingTop: 20, borderTop: '1px solid #F3F4F6' }}>
          {[
            { label: 'Сотрудников', value: store.employeeCount, color: '#4A6CF7' },
            { label: 'Активных задач', value: store.activeTasks, color: '#FF9500' },
            { label: 'Товаров', value: store.productCount, color: '#8B5CF6' },
            { label: 'Задач выполнено', value: storeStats?.tasksCompleted || 0, color: '#34C759' },
          ].map(s => (
            <div key={s.label} style={{ textAlign: 'center' }}>
              <div style={{ fontSize: 26, fontWeight: 800, color: s.color }}>{s.value}</div>
              <div style={{ fontSize: 12, color: '#8E8E93', marginTop: 2 }}>{s.label}</div>
            </div>
          ))}
        </div>
      </Card>

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
        <Card title={`Сотрудники (${storeEmployees.length})`} padding="0">
          <Table columns={empColumns} data={storeEmployees} emptyText="Нет сотрудников" pageSize={5} />
        </Card>
        <Card title={`Задачи (${storeTasks.length})`} padding="0">
          <Table columns={taskColumns} data={storeTasks} emptyText="Нет задач" pageSize={5} />
        </Card>
      </div>
    </div>
  );
}
